import React from 'react';
import {Button, Typography, Grid, Box, Card, CardMedia} from '@material-ui/core/';
import {
    Link
} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import img from "./ExampleGrubHubStatement.png";

const useStyles = makeStyles({
    root: {
        maxWidth: 500,
        maxHeight:300
    },
    media: {
      height: 300,
      width: 500
    },
});


export default function LandingPage(props){
 const classes = useStyles();
 return(
    <div>
    <Box m={5}>
    <Typography variant='h2' gutterBottom>How much is GrubHub Taking From You? </Typography>
    </Box>
    <Box m={5}>
    <Grid container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        >
    <Grid item xs={12}>
    <Card className={classes.root}>
        <CardMedia className={classes.media} image={img}/>
    </Card>
    </Grid>
    </Grid>
    </Box>
    <Box m={5}>
    {/* <Typography variant='h5' align='left' gutterBottom>We're writing an Open Letter on behalf of restaurants, 
                            who are getting overcharged commissions by GrubHub during the COVID-19 pandemic. 
                                The first step to empowering restaurants is transparency, and to support this initiative, 
                                we're offering restaurant owners a calculator to visualize their potential losses if they were to begin 
                                or continue a partnership with Grubhub.</Typography> */}
    <Typography variant='h5' gutterBottom>GrubHub statements are confusing. Find out how much GrubHub commissions are eating into your sales, or how much they will if you partner. 
    </Typography>
    <Typography variant='h5' gutterBottom>To get started, who are you?</Typography>
    </Box>
    <Grid container spacing={3}>
    <Grid item xs={6}>
      <Button variant="contained" color="primary" component={Link} to='/restaurant'>
      I'm a restaurant owner.
      </Button>
    </Grid>
    <Grid item xs={6}>
      <Button variant="contained" color="primary" component={Link} to='/ally'>
      I'm an ally.
      </Button>
    </Grid>
    </Grid>
    </div>
 );
}
